// Sistema escalável de rastreamento de origem do menu
// Mantém o item correto do menu selecionado para rotas compartilhadas
document.addEventListener('DOMContentLoaded', function() {
  
  // Configuração de rotas compartilhadas (deve coincidir com o helper Rails)
  const SHARED_ROUTES = [
    '/funcionarios',
    '/dp_avulsos',
    '/dp_avulsos/new',
    '/dp_avulsos/liberadas'
  ];
  
  // Função para capturar cliques em links que levam para rotas compartilhadas
  const trackMenuOrigin = () => {
    const linksWithOrigin = document.querySelectorAll('a[href*="origin="]');
    
    linksWithOrigin.forEach(link => {
      link.addEventListener('click', function(e) {
        const url = new URL(this.href);
        const origin = url.searchParams.get('origin');
        
        if (origin) {
          // Armazenar a origem no sessionStorage para persistência
          sessionStorage.setItem('menu_origin', origin);
          console.log(`Origem definida: ${origin} para URL: ${this.href}`);
        }
      });
    });
  };

  // Função para manter a origem em navegações subsequentes
  const maintainOrigin = () => {
    const currentPath = window.location.pathname;
    const storedOrigin = sessionStorage.getItem('menu_origin');
    
    // Se estivermos em uma rota compartilhada
    if (SHARED_ROUTES.includes(currentPath) && storedOrigin) {
      console.log(`Mantendo origem: ${storedOrigin} para rota compartilhada: ${currentPath}`);
      
      // Adicionar indicador visual adicional se necessário
      document.body.setAttribute('data-menu-origin', storedOrigin);
    }
  };

  // Função para limpar origem quando sair de contextos específicos
  const clearOriginOnNavigate = () => {
    // Lista de rotas que devem limpar a origem
    const clearOriginRoutes = ['/dashboard', '/'];
    
    if (clearOriginRoutes.some(route => window.location.pathname === route)) {
      sessionStorage.removeItem('menu_origin');
    }
  };

  // Inicializar todas as funcionalidades
  trackMenuOrigin();
  maintainOrigin();
  clearOriginOnNavigate();
  
  // Escutar mudanças de navegação (para SPAs com Turbo/HTMX)
  document.addEventListener('turbo:load', function() {
    trackMenuOrigin();
    maintainOrigin();
  });
});
